import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { IDataFilter } from "../commons/types/interfaces/filters.interfaces";
import { IUserListResponse } from "../commons/types/interfaces/users.interfaces";
import {
  IDocument,
  IDocumentListResponse,
} from "../commons/types/interfaces/documents.interface";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  constructor(private http: HttpClient) {}

  getDocuments(payload: IDataFilter): Observable<any> {
    const url = `${environment.BASE_URL}/documents?fieldsToBeSearch=${payload.fieldsToBeSearch}&fullSearch=${payload.fullSearch}&search=${payload.search}&sortOrder=${payload.sortOrder}&page=${payload.page}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}`;
    return this.http.get<IDocumentListResponse>(url);
  }

  getAIDocuments(payload: IDataFilter): Observable<any> {
    const url = `${environment.BASE_URL}/documents/ai-search?fieldsToBeSearch=${payload.fieldsToBeSearch}&fullSearch=${payload.fullSearch}&search=${payload.search}&sortOrder=${payload.sortOrder}&page=${payload.page}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&nextPageToken=${payload.nextPageToken}`;
    return this.http.get<IDocumentListResponse>(url);
  }

  getDocumentDetail(documentId: string): Observable<any> {
    const url = `${environment.BASE_URL}/documents/${documentId}`;
    return this.http.get<IDocument>(url);
  }

  getDocumentFile(
    bucketName: string = "",
    key: string = "",
    expiresIn: string
  ): Observable<any> {
    const urlEncodedParams = encodeURIComponent(`${key}`);
    const url = `${environment.BASE_URL}/documents/get-presigned-url?key=${urlEncodedParams}&expiresIn=${expiresIn}&bucket=${bucketName}`;
    return this.http.get<IDocument>(url);
  }

  getDocumentTypes(): Observable<any> {
    const url = `${environment.BASE_URL}/documents/document-types`;
    return this.http.get<IDocument>(url);
  }
}
